import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { Route, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Alert from 'react-s-alert';
import {toggleSidebar} from '../actions/system';
import TopMenu from './parts/TopMenu';
import Sidebar from './parts/Sidebar';
class UserLayout extends Component {
    constructor() {
        super();
        this.state = {
            smallMenu: false
        };
    }

    render() {
        const { authenticated, user, toggleSidebar, location, sideBarOpen, component: Component, ...rest } = this.props;
        return (
            <Route
                {...rest}
                render={props =>
                    authenticated ? (
                        <div className="grid">
                            <TopMenu toggleSidebar={toggleSidebar} 
                                userName={user.name} 
                                mobile={false}
                                history={this.props.history}/>
                            <div id="main-content">
                                <div className="parent">
                                    <Sidebar 
                                        history={this.props.history}
                                        currentLocation={location}
                                        sideBarClosed={!sideBarOpen} />
                                    <div
                                        id={
                                            (!sideBarOpen
                                                ? "small-content "
                                                : "") + "dls-content"
                                        }
                                    >
                                        <Component {...props} />
                                        <Alert stack={{limit: 3}} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <Redirect to="/auth/login" />
                    )
                }
            />
        );
    }
}
//
UserLayout.propTypes = {
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
    component: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    location: PropTypes.object,
    toggleSidebar: PropTypes.func,
    sideBarOpen: PropTypes.bool,
    user: PropTypes.object
};

function mapStateToProps(state) {
    return {
        isAuthenticated: state.auth.authenticated,
        sideBarOpen: state.system.ui.sidebar,
        user: state.auth.user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleSidebar
    }, dispatch);
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(UserLayout));



// WEBPACK FOOTER //
// ./src/routes/Layout.js